<script lang="ts">
export default {
  name: 'DialogContent',
};
</script>

<script setup lang="ts">
import { computed } from 'vue';
import { DialogClose, DialogContent, DialogOverlay, DialogPortal } from 'reka-ui';
import { X } from 'lucide-vue-next';
import { cn } from '@/lib/utils';

interface Props {
  class?: string;
}

const props = defineProps<Props>();

const contentClass = computed(() =>
  cn(
    'tw:fixed tw:left-[50%] tw:top-[50%] tw:z-50 tw:grid tw:w-full tw:max-w-lg tw:translate-x-[-50%] tw:translate-y-[-50%] tw:gap-4 tw:border tw:bg-background tw:p-6 tw:shadow-lg tw:duration-200 tw:data-[state=open]:animate-in tw:data-[state=closed]:animate-out tw:data-[state=closed]:fade-out-0 tw:data-[state=open]:fade-in-0 tw:data-[state=closed]:zoom-out-95 tw:data-[state=open]:zoom-in-95 tw:data-[state=closed]:slide-out-to-left-1/2 tw:data-[state=closed]:slide-out-to-top-[48%] tw:data-[state=open]:slide-in-from-left-1/2 tw:data-[state=open]:slide-in-from-top-[48%] tw:sm:rounded-lg',
    props.class,
  ),
);
</script>

<template>
  <DialogPortal>
    <DialogOverlay
      class="tw:fixed tw:inset-0 tw:z-50 tw:bg-black/60 tw:data-[state=open]:animate-in tw:data-[state=closed]:animate-out tw:data-[state=closed]:fade-out-0 tw:data-[state=open]:animate-overlayShow" />
    <DialogContent :class="contentClass" v-bind="$attrs">
      <slot />
      <DialogClose
        class="tw:absolute tw:right-4 tw:top-4 tw:rounded-sm tw:opacity-70 tw:ring-offset-background tw:transition-opacity tw:hover:opacity-100 tw:focus:outline-none tw:focus:ring-2 tw:focus:ring-offset-2 tw:disabled:pointer-events-none tw:data-[state=open]:bg-accent tw:data-[state=open]:text-muted-foreground">
        <X class="tw:h-4 tw:w-4" />
        <span class="tw:sr-only">Close</span>
      </DialogClose>
    </DialogContent>
  </DialogPortal>
</template>
